// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ddf06e6f","239":"67554f86","453":"56c5e21a","455":"f762da00"}[chunkId] + ".chunk.js";
};